import React, { useEffect, useState } from "react";

export default function LandingPage() {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const phoneNumber = "tel:+919686419682";
  const emailAddress = "mailto:autobodyworksperfect@gmail.com";
  const mapLink =
    "https://maps.app.goo.gl/JVJnnwmY1p4P7MUGA";

  /* ================= DESKTOP VIEW ================= */
  if (isDesktop) {
    return (
        <section id="home">
      <div className="relative min-h-screen w-full bg-[url('/images/bg/desktop-bg.jpeg')] bg-cover bg-center flex items-center">
        {/* Overlay */}
        <div className="absolute inset-0 bg-black/45" />

        {/* CENTER TEXT */}
        <div className="relative z-10 mx-auto text-center px-6">
          <h1 className="text-8xl font-extrabold tracking-wide text-slate-300">
            Perfect Auto Body Works
          </h1>

          <p className="mt-6 text-3xl text-slate-300">
            Complete Auto Body, Mechanical & Interior Solutions
          </p>

          <p className="mt-3 text-2xl text-slate-400">
            Jeep • Cars • Tempo • Pick-Up Vehicles
          </p>
        </div>

        {/* RIGHT SIDE VERTICAL CARDS */}
        <div className="absolute right-12 z-10 flex flex-col gap-8">
          {/* Contact Card */}
          <a
            href={phoneNumber}
            className="bg-black/70 backdrop-blur-md border border-slate-500/40 rounded-3xl px-10 py-8 w-80 hover:scale-105 transition"
          >
            <h3 className="text-3xl font-bold text-slate-100 mb-2">
              📞 Contact
            </h3>
            <p className="text-2xl text-slate-300">+91 96864 19682</p>
            <p className="text-xl text-slate-400 mt-1">
              Mon – Sat • 9AM – 7PM
            </p>
          </a>

          {/* Email Card */}
          <a
            href={emailAddress}
            className="bg-black/70 backdrop-blur-md border border-slate-500/40 rounded-3xl px-10 py-8 w-80 hover:scale-105 transition"
          >
            <h3 className="text-3xl font-bold text-slate-100 mb-2">
              ✉️ Email
            </h3>
            <p className="text-lg text-slate-300 break-all">
              autobodyworksperfect@gmail.com
            </p>
          </a>

          {/* Location Card */}
          <a
            href={mapLink}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-black/70 backdrop-blur-md border border-slate-500/40 rounded-3xl px-10 py-8 w-80 hover:scale-105 transition"
          >
            <h3 className="text-3xl font-bold text-slate-100 mb-2">
              📍 Location
            </h3>
            <p className="text-2xl text-slate-300">
              Perfect Auto Body Works
            </p>
            <p className="text-xl text-slate-400 mt-1">
              Mangalore, Karnataka
            </p>
          </a>
        </div>
      </div>
      </section>
    );
  }

 
  return (
    <section id="home">
    <div className="relative min-h-screen w-full bg-[url('/images/bg/mobile-bg.png')] bg-cover bg-center">
      <div className="absolute inset-0 bg-black/45" />

      {/* CENTER TEXT */}
      <div className="relative z-10 text-center px-4 pt-24">
        <h1 className="text-5xl font-extrabold text-slate-100">
          Perfect Auto Body Works
        </h1>

        <p className="mt-4 text-2xl text-slate-300">
          Auto Body • Mechanical • Interior
        </p>
      </div>

      {/* BOTTOM VERTICAL CARDS */}
      <div className="absolute bottom-6 left-0 right-0 z-10 flex flex-col gap-4 px-4">
        {/* Contact */}
        <a
          href={phoneNumber}
          className="bg-black/70 backdrop-blur-md border border-slate-500/40 rounded-2xl px-6 py-5 text-center"
        >
          <h3 className="text-2xl font-bold text-slate-100">📞 Call</h3>
          <p className="text-xl text-slate-300 mt-1">+91 96864 19682</p>
        </a>

        {/* Email */}
        <a
          href={emailAddress}
          className="bg-black/70 backdrop-blur-md border border-slate-500/40 rounded-2xl px-6 py-5 text-center"
        >
          <h3 className="text-2xl font-bold text-slate-100">✉️ Email</h3>
          <p className="text-lg text-slate-300 mt-1 break-all">autobodyworksperfect@gmail.com</p>
        </a>

        {/* Location */}
        <a
          href={mapLink}
          target="_blank"
          rel="noopener noreferrer"
          className="bg-black/70 backdrop-blur-md border border-slate-500/40 rounded-2xl px-6 py-5 text-center"
        >
          <h3 className="text-2xl font-bold text-slate-100">📍 Location</h3>
          <p className="text-xl text-slate-300 mt-1">
            Mangalore, Karnataka
          </p>
        </a>
      </div>
    </div>
    </section>
  );
}
